import {LocationDetails} from '../data-objects/location-details';

export class AddressViewmodel {
  showErrorMessage = false;
  addressInvalid: boolean;
  addressValidated: boolean;

  addressDetails: LocationDetails;
  multipleAddressDetails: LocationDetails[];
  errorMessage: string;

  addressHasValues = false;
  addressHasPlan = false;
  addressHasStreetName=false;
  addressHasStreetNo=false;
  addressHasStreetType=false;
  addressHasSuburb=false;

  constructor() {
    this.addressDetails = new LocationDetails();
    this.addressDetails.state = 'VIC';
  }

  clear() {
    this.addressDetails.clear();
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/viewmodels/address-viewmodel.ts